import { render, staticRenderFns } from "./EditVisitorDetail.vue?vue&type=template&id=635360bf&scoped=true&name=addVisitorDetail&"
import script from "./EditVisitorDetail.vue?vue&type=script&lang=js&"
export * from "./EditVisitorDetail.vue?vue&type=script&lang=js&"
import style0 from "./EditVisitorDetail.vue?vue&type=style&index=0&id=635360bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635360bf",
  null
  
)

export default component.exports